<template>
	<div class="sf-datatable-wrapper">
		<div class="sf-datatable-container">
			<div class="sf-table">
				<table class="qms-table">
					<tbody>
						<tr>
							<!-- 비고 -->
							<th class="col-1">{{ getMessage_('QWCC000906') }}</th>
							<td class="col-3">
								<el-input
									id="rmk"
									type="textarea"
									v-model="formInfo.rmk"
									:inputValue="formInfo.rmk"
									:rows="1"
									maxlength="33"
									show-word-limit
									@change="value => onChangeParam({ key: 'rmk', value })"
								/>
							</td>
							<!-- lot번호 From -->
							<th class="col-1">* {{ getMessage_('QWCC001470') }}</th>
							<td class="col-1">
								<el-input
									id="lotFromNo"
									type="input"
									v-model="formInfo.lotFromNo"
									:inputValue="formInfo.lotFromNo"
									:rows="1"
									maxlength="30"
									show-word-limit
									@change="value => onUpperChangeParam({ key: 'lotFromNo', value })"
								/>
							</td>
							<!-- lot번호 To -->
							<th class="col-1">* {{ getMessage_('QWCC001469') }}</th>
							<td class="col-1">
								<el-input
									id="lotToNo"
									type="input"
									v-model="formInfo.lotToNo"
									:inputValue="formInfo.lotToNo"
									:rows="1"
									maxlength="30"
									show-word-limit
									@change="value => onUpperChangeParam({ key: 'lotToNo', value })"
								/>
							</td>
							<!-- 첨부파일 -->
							<th class="col-1">{{ getMessage_('QWCC000039') }}</th>
							<td class="col-1">
								<template>
									<file-upload-list
										id="partCkuFile"
										ref="partCkuFileRef"
										width="100%"
										height="100%"
										:propFileList="formInfo.partCkuFileDb"
										maxQuantity="1"
										@MultiFile="partCkufileUpload"
										@onDownload="onDownloadFile"
									></file-upload-list>
								</template>
							</td>
						</tr>
					</tbody>
				</table>
				<table class="qms-table">
					<tbody>
						<tr>
							<!-- 이력 -->
							<th class="col-1">{{ getMessage_('SWCC000747') }}</th>
							<td class="col-3">
								<el-input id="input2" type="textarea" v-model="formInfo.rmkHis" :inputValue="formInfo.rmkHis" :rows="2" readOnly />
							</td>
							<!-- 단품판정 x1 ~ x10까지 결과 시작 -->
							<th class="col-1">X1 ~ X10</th>
							<td class="col-5">
								<table class="qms-table">
									<tbody>
										<tr>
											<!-- <th class="col-1 reject"> -->
											<th :class="jgmtReslutList.x1 === 'NG' ? 'col-1 reject rsltNg' : 'col-1 reject'">
												<sf-select-group
													label="X1"
													labelPosition="top"
													:labelSpan="1"
													:inputValue="jgmtReslutList.x1"
													:options="getIndvJgmtCdList_"
													:disabled="this.jgmtDisabled()"
												/>
											</th>
											<th :class="jgmtReslutList.x2 === 'NG' ? 'col-1 reject rsltNg' : 'col-1 reject'">
												<sf-select-group
													label="X2"
													labelPosition="top"
													:labelSpan="1"
													:inputValue="jgmtReslutList.x2"
													:options="getIndvJgmtCdList_"
													:disabled="this.jgmtDisabled()"
												/>
											</th>
											<th :class="jgmtReslutList.x3 === 'NG' ? 'col-1 reject rsltNg' : 'col-1 reject'">
												<sf-select-group
													label="X3"
													labelPosition="top"
													:labelSpan="1"
													:inputValue="jgmtReslutList.x3"
													:options="getIndvJgmtCdList_"
													:disabled="this.jgmtDisabled()"
												/>
											</th>
											<th :class="jgmtReslutList.x4 === 'NG' ? 'col-1 reject rsltNg' : 'col-1 reject'">
												<sf-select-group
													label="X4"
													labelPosition="top"
													:labelSpan="1"
													:inputValue="jgmtReslutList.x4"
													:options="getIndvJgmtCdList_"
													:disabled="this.jgmtDisabled()"
												/>
											</th>
											<th :class="jgmtReslutList.x5 === 'NG' ? 'col-1 reject rsltNg' : 'col-1 reject'">
												<sf-select-group
													label="X5"
													labelPosition="top"
													:labelSpan="1"
													:inputValue="jgmtReslutList.x5"
													:options="getIndvJgmtCdList_"
													:disabled="this.jgmtDisabled()"
												/>
											</th>
											<th :class="jgmtReslutList.x6 === 'NG' ? 'col-1 reject rsltNg' : 'col-1 reject'">
												<sf-select-group
													label="X6"
													labelPosition="top"
													:labelSpan="1"
													:inputValue="jgmtReslutList.x6"
													:options="getIndvJgmtCdList_"
													:disabled="this.jgmtDisabled()"
												/>
											</th>
											<th :class="jgmtReslutList.x7 === 'NG' ? 'col-1 reject rsltNg' : 'col-1 reject'">
												<sf-select-group
													label="X7"
													labelPosition="top"
													:labelSpan="1"
													:inputValue="jgmtReslutList.x7"
													:options="getIndvJgmtCdList_"
													:disabled="this.jgmtDisabled()"
												/>
											</th>
											<th :class="jgmtReslutList.x8 === 'NG' ? 'col-1 reject rsltNg' : 'col-1 reject'">
												<sf-select-group
													label="X8"
													labelPosition="top"
													:labelSpan="1"
													:inputValue="jgmtReslutList.x8"
													:options="getIndvJgmtCdList_"
													:disabled="this.jgmtDisabled()"
												/>
											</th>
											<th :class="jgmtReslutList.x9 === 'NG' ? 'col-1 reject rsltNg' : 'col-1 reject'">
												<sf-select-group
													label="X9"
													labelPosition="top"
													:labelSpan="1"
													:inputValue="jgmtReslutList.x9"
													:options="getIndvJgmtCdList_"
													:disabled="this.jgmtDisabled()"
												/>
											</th>
											<th :class="jgmtReslutList.x10 === 'NG' ? 'col-1 reject rsltNg' : 'col-1 reject'">
												<sf-select-group
													label="X10"
													labelPosition="top"
													:labelSpan="1"
													:inputValue="jgmtReslutList.x10"
													:options="getIndvJgmtCdList_"
													:disabled="this.jgmtDisabled()"
												/>
											</th>
										</tr>
									</tbody>
								</table>
							</td>
						</tr>
					</tbody>
				</table>
			</div>
		</div>
	</div>
</template>

<script>
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@pqy/pcku/PartCku/store/helpers';
import FileUploadList from '@qms/Components/FileUploadList.vue';

export default {
	data() {
		return {
			data: '',
			date1: '',
			date2: '',
			input1: '',
			input2: ''
		};
	},
	props: {
		scrId: { type: String, default: '' }
	},
	components: { FileUploadList },
	computed: {
		...rootComputed,
		...serviceComputed
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		onChangeParam(payload) {
			this.$sf_toggleLoading(true);
			this.onChangeParam_(payload)
				.catch(error => {
					this.$sf_toast({ type: 'error', message: error.message });
				})
				.finally(() => this.$sf_toggleLoading(false));
		},
		onUpperChangeParam({ key, value }) {
			const upValue = value.toUpperCase();
			const regEx = /[^A-Z0-9]/g; //숫자와 영문자(대문자)만 가능
			let val = upValue.replace(regEx, '');
			this.onChangeParam_({ key, value: val });
		},
		jgmtDisabled() {
			// const { type } = this.popupParams;
			// return type.includes('update');
			return true;
		},
		async onDownloadFile(file) {
			const { fileId, fileSeq } = file;
			await this.fileDownload_({ fileId, fileSeq });
		},
		partCkufileUpload(saveList) {
			this.onChangeParam_({ key: 'partCkuFile', value: saveList });
		}
	}
};
</script>

<style lang="scss" scoped>
.sf-input-group-wrapper__label {
	height: 0px;
}
.reject {
	height: 0px;
	padding: 3px;
}
</style>
